



























import { Component, Vue } from "vue-property-decorator";
import { TodayLoader, TodayData } from "../../guidelines/todayData";
import { DayDone, GuidelineApi } from "./guidelineApi";
import CzLink from "../cz/CzLink.vue";
import { ProgramPackTexts } from "../../bookings/programPackTexts";
import CzCard from "../cz/CzCard.vue";
import CzTitle from "../cz/CzTitle.vue";
import CzRing from "../cz/CzRing.vue";
import CzPlanRow from "../cz/CzPlanRow.vue";
import CzButton from "../cz/CzButton.vue";
import ProgramProgress from "../programs/ProgramProgress.vue";

const Shown = 3;

// The way into "Today" from the bookings list: what is done today, the next things to do and the programs in progress.
@Component({ components: { CzCard, CzTitle, CzRing, CzPlanRow, CzButton, CzLink, ProgramProgress } })
export default class TodayCard extends Vue {
  data: TodayData = { today: "", rows: [], bookings: [], surveys: [], programs: [], programByGuideline: {} };
  texts = ProgramPackTexts;

  get visible(): boolean {
    return this.total > 0 || this.data.programs.length > 0;
  }

  get total(): number {
    return TodayLoader.count(this.data);
  }

  get done(): number {
    return TodayLoader.done(this.data);
  }

  get ringLabel(): string {
    return this.$t("{0} of {1} done today").toString().replace("{0}", String(this.done)).replace("{1}", String(this.total));
  }

  get dateLabel(): string {
    if (!this.data.today) return "";
    return new Intl.DateTimeFormat(ProgramPackTexts.culture(), { weekday: "long", day: "numeric", month: "long" }).format(new Date(this.data.today + "T12:00:00"));
  }

  get items(): any[] {
    const bookings = this.data.bookings.map((b: any) => ({ key: "b" + b.id, title: b.bookingType, sub: (b.dtStart || "").substring(11, 16), done: false, to: "/customer-bookings", action: this.$t("View").toString() }));
    const surveys = this.data.surveys.map((s: any) => ({ key: "s" + s.id, title: s.survey, sub: this.$t("Questionnaire").toString(), done: false, to: `/survey/${s.token}`, action: this.$t("Answer").toString() }));
    const rows = this.data.rows.map((r: any) => ({ key: "g" + r.id, title: r.name, sub: this.guidelineSub(r), done: r.todayStatus === DayDone, to: GuidelineApi.link(r, this.$route.fullPath), action: this.$t(r.todayStatus === DayDone ? "View" : "Do it").toString() }));
    return bookings.concat(surveys, rows).sort((a, b) => Number(a.done) - Number(b.done));
  }

  get shownItems(): any[] {
    return this.items.slice(0, Shown);
  }

  get nextItem(): any {
    return this.items.find((i: any) => !i.done) || null;
  }

  guidelineSub(r: any): string {
    return r.todayStatus === null && r.nextSessionTitle ? this.$t("Your turn: {0}").toString().replace("{0}", r.nextSessionTitle) : "";
  }

  programDone(e: any): string {
    return this.$t("{0} of {1} done").toString().replace("{0}", String(ProgramPackTexts.done(e))).replace("{1}", String(ProgramPackTexts.sessions(e)));
  }

  async mounted() {
    this.data = await TodayLoader.load();
  }
}
